import { ArrowLeft } from "react-feather"
import { useNavigate } from "react-router-dom"
import { propertyApi } from "@/api/client/property"
import { Button } from "@/components/ui/button/button"

interface PropertyHeaderProps {
  /**
   * 物件ID
   */
  propertyId: number
  /**
   * 戻るボタンのカスタムハンドラー（オプション）
   */
  onBack?: () => void
}

/**
 * 物件詳細画面で使用するヘッダーコンポーネント
 * 戻るボタンと物件名を表示
 * 物件情報はAPIから自動で取得され、戻るボタンで物件詳細ページに遷移
 */
export function PropertyHeader({ propertyId, onBack }: PropertyHeaderProps) {
  const navigate = useNavigate()

  const { data: propertyResponse } = propertyApi.usePropertyGet(
    propertyId,
    {},
    {
      query: {
        enabled: !!propertyId,
      },
    }
  )

  const property = propertyResponse?.property

  const handleBack = () => {
    if (onBack) {
      onBack()
    } else {
      navigate(`/properties/${propertyId}`, { state: { shouldRefetch: true } })
    }
  }

  return (
    <div className="flex items-center gap-2.5">
      <Button variant="outline" size="sm" onClick={handleBack}>
        <ArrowLeft className="h-4 w-4 text-primary" />
        戻る
      </Button>
      <h1 className="text-base font-semibold text-primary truncate">
        物件：{property?.name || "読み込み中..."}
      </h1>
    </div>
  )
}
